import { Restore } from '@mui/icons-material';
import { IconButton, ImageListItemBar, Stack, Tooltip, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Account } from 'types/Account';
import ExportImage from './ExportImage';
import ExportVideo from './ExportVideo';
import PlaybackDateTimeModal from './PlaybackDateTimeModal';

function CameraPlayerBar({
  camName,
  accountSelected,
}: {
  camName: string;
  accountSelected: Account;
}) {
  const { t } = useTranslation('cameras');
  const [open, setOpen] = React.useState(false);

  return (
    <>
      <ImageListItemBar
        title={
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Typography>{camName}</Typography>
            <Stack direction="row" gap={0.5}>
              <ExportImage {...{ accountSelected, camName }} />
              {(accountSelected.hasRecordingEnabled ||
                accountSelected.hasSIMCloudRecordingEnabled) && (
                <>
                  <ExportVideo {...{ accountSelected, camName }} />
                  <Tooltip title={t('see_a_recording')} arrow>
                    <IconButton color="inherit" size="small" onClick={() => setOpen(true)}>
                      <Restore fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </>
              )}
            </Stack>
          </Stack>
        }
        sx={{
          borderBottomLeftRadius: '4px',
          borderBottomRightRadius: '4px',
          '.MuiImageListItemBar-titleWrap': {
            px: 3,
            py: 0.5,
          },
        }}
      />
      <PlaybackDateTimeModal {...{ open, setOpen }} />
    </>
  );
}

export default CameraPlayerBar;
